<template>
  <el-card class="dynamic-table-card" shadow="hover">
    <!-- 表格工具栏 -->
    <div class="table-toolbar" v-if="showColumnSelector || showExport">
      <div class="toolbar-left">
        <!-- <span class="table-title">数据列表</span> -->
      </div>
      <div class="toolbar-right">
        <!-- 导出CSV按钮 -->
        <el-tooltip content="导出CSV" placement="top" v-if="showExport">
          <el-button 
            :icon="Download" 
            circle 
            size="small"
            @click="exportToCSV"
          />
        </el-tooltip>
        
        <!-- 列选择器 -->
        <div class="column-selector-wrapper" >
          <el-tooltip content="列选择器" placement="top">
            <el-button 
              :icon="Setting" 
              circle 
              size="small"
              @click="toggleColumnSelector"
              :readonly="allColumns.length === 0"
            />
          </el-tooltip>
          
          <!-- 自定义列选择器 -->
          <div 
            v-show="showColumnSelectorPopup" 
            class="custom-column-selector"
            @click.stop
          >
            <div class="selector-header">
              <span>选择要显示的列</span>
              <el-button 
                v-if="allColumns.length > 0"
                type="text" 
                size="small" 
                @click="selectAllColumns"
              >
                全选
              </el-button>
            </div>
            <div class="selector-content">
              <div v-if="allColumns.length === 0" class="no-columns-tip">
                暂无列数据
              </div>
              <div 
                v-else
                v-for="column in allColumns" 
                :key="column.key"
                class="column-item"
                @click="toggleColumn(column.key)"
              >
                <el-checkbox 
                  :value="column.key"
                  :readonly="column.key === '编码'"
                  :model-value="visibleColumns.includes(column.key)"
                  @change="toggleColumn(column.key)"
                >
                  {{ column.label }}
                </el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 表格容器 -->
    <el-table 
      ref="tableRef"
      :data="filteredData" 
      border 
      stripe 
      style="width: 100%"
      v-loading="loading"
      :max-height="maxHeight"
      :row-class-name="getRowClassName"
       @selection-change="handleSelectionChange"
    >
     <!-- 选择列 -->
      <el-table-column 
        v-if="showSelection" 
        type="selection" 
        width="55"
      />
        <!-- 动态列 -->
        <el-table-column 
          v-for="column in visibleTableColumns" 
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          :min-width="column.minWidth"
          :sortable="false"
          :show-overflow-tooltip="true"
        >
          <!-- 自定义单元格内容 -->
          <template #default="{ row }">
            {{ formatCellValue(row[column.prop], column.prop) }}
          </template>
          
          <!-- 表头筛选区域 -->
         <template #header="{ column: col }">
            <div class="table-header-filter">
              <div class="header-row">
                <span class="header-title">{{ col.label }}</span>
                <div class="header-controls">
                  <!-- 排序按钮 -->
                  <div class="sort-controls">
                    <el-tooltip content="排序" placement="top">
                      <div class="sort-icons-container">
                        <div 
                          class="sort-icon sort-icon-up"
                          :class="{ 'active': getSortState(col.property) === 1 }"
                          @click="handleSort(col.property, 1)"
                        >
                          <el-icon><CaretTop /></el-icon>
                        </div>
                        <div 
                          class="sort-icon sort-icon-down"
                          :class="{ 'active': getSortState(col.property) === 2 }"
                          @click="handleSort(col.property, 2)"
                        >
                          <el-icon><CaretBottom /></el-icon>
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                  
                  <!-- 筛选按钮 -->
                  <div v-if="getFilterConfig(col.property)">
                  <!-- 筛选条件 -->
                  <div class="filter-controls" v-if="getFilterConfig(col.property)?.Type === 3">
                            <el-dropdown
                              @command="(command: string, event: Event) => handleFilter(col.property, command, event)"
                              trigger="click"
                              placement="bottom"
                              :hide-on-click="false"
                            >
                      <el-button 
                        type="primary" 
                        size="small" 
                        :icon="Filter"
                        circle
                        class="filter-btn"
                        @click.stop="!getActiveFilterType(col.property) && getFilterOptions(col.property).length ? setFilterType(col.property, getFilterOptions(col.property)[0].value) : undefined"
                      />
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item
                            v-for="option in getFilterOptions(col.property)"
                            :key="option.value"
                            :command="`filter_${col.property}_${option.value}`"
                            :class="{ 'filter-option-selected': getActiveFilterType(col.property) === option.value }"
                          >
                            <span class="filter-option-content">
                              <span class="filter-option-label">{{ option.label }}</span>
                              <span v-if="getActiveFilterType(col.property) === option.value" class="filter-option-check">✓</span>
                            </span>
                          </el-dropdown-item>
                          <!-- 输入框选项 - 始终显示 -->
                          <el-dropdown-item
                            v-if="getFilterConfig(col.property)?.Type === 3"
                            :command="`input_${col.property}`"
                            divided
                          >
                            <div class="filter-input-item">
                              <!-- 字符串类型输入 -->
                              <div v-if="getFieldType(col.property) === 'string' && getActiveFilterType(col.property) !== 'between'" class="input-with-buttons" @keydown.enter.stop.prevent="confirmFilter(col.property)">
                                <el-input
                                  :model-value="getFilterValue(col.property, 'value1')"
                                  @update:model-value="(value: any) => setFilterValue(col.property, 'value1', value)"
                                  placeholder="输入筛选内容"
                                  size="small"
                                  @click.stop
                                  style="width: 100px"
                                />
                                <div class="filter-buttons">
                                  <el-button size="small" type="primary" @click="confirmFilter(col.property)" @click.stop>
                                    确定
                                  </el-button>
                                  <el-button size="small" @click="resetFilter(col.property)" @click.stop>
                                    重置
                                  </el-button>
                                </div>
                              </div>
                              
                              <!-- 数值类型输入 -->
                              <div v-else-if="(getFieldType(col.property) === 'int32' || getFieldType(col.property) === 'int64' || getFieldType(col.property) === 'int' || getFieldType(col.property) === 'number') && getActiveFilterType(col.property) !== 'between'" class="input-with-buttons" @keydown.enter.stop.prevent="confirmFilter(col.property)">
                                <el-input
                                  :model-value="getFilterValue(col.property, 'value1')"
                                  @update:model-value="(value: any) => setFilterValue(col.property, 'value1', value)"
                                  placeholder="输入数值"
                                  size="small"
                                  type="number"
                                  @click.stop
                                  style="width: 100px"
                                />
                                <div class="filter-buttons">
                                  <el-button size="small" type="primary" @click="confirmFilter(col.property)" @click.stop>
                                    确定
                                  </el-button>
                                  <el-button size="small" @click="resetFilter(col.property)" @click.stop>
                                    重置
                                  </el-button>
                                </div>
                              </div>
                              
              <!-- 介于类型输入 - 两个输入框 -->
                              <div v-if="getActiveFilterType(col.property) === 'between' && getFieldType(col.property) !== 'datetime'" class="between-inputs" @keydown.enter.stop.prevent="confirmFilter(col.property)">
                                <div class="between-input-row">
                                  <el-input
                                    :model-value="getFilterValue(col.property, 'value1')"
                                    @update:model-value="(value: any) => setFilterValue(col.property, 'value1', value)"
                                    placeholder="最小值"
                                    size="small"
                                    type="number"
                                    @click.stop
                                    style="width: 70px"
                                  />
                                  <span class="between-separator">~</span>
                                  <el-input
                                    :model-value="getFilterValue(col.property, 'value2')"
                                    @update:model-value="(value: any) => setFilterValue(col.property, 'value2', value)"
                                    placeholder="最大值"
                                    size="small"
                                    type="number"
                                    @click.stop
                                    style="width: 70px"
                                  />
                                </div>
                                <div class="filter-buttons">
                                  <el-button size="small" type="primary" @click="confirmFilter(col.property)" @click.stop>
                                    确定
                                  </el-button>
                                  <el-button size="small" @click="resetFilter(col.property)" @click.stop>
                                    重置
                                  </el-button>
                                </div>
                              </div>
                              
                              <!-- DateTime类型时间选择器 -->
                              <div v-else-if="getFieldType(col.property) === 'datetime' && getActiveFilterType(col.property) !== 'between'" class="datetime-inputs" @keydown.enter.stop.prevent="confirmFilter(col.property)">
                                <el-date-picker
                                  :model-value="getFilterValue(col.property, 'value1')"
                                  @update:model-value="(value: any) => setFilterValue(col.property, 'value1', value)"
                                  type="datetime"
                                  placeholder="选择日期时间"
                                  size="small"
                                  style="width: 180px"
                                  format="YYYY-MM-DD HH:mm:ss"
                                  value-format="YYYY-MM-DD HH:mm:ss"
                                />
                                <div class="filter-buttons">
                                  <el-button size="small" type="primary" @click="confirmFilter(col.property)" @click.stop>
                                    确定
                                  </el-button>
                                  <el-button size="small" @click="resetFilter(col.property)" @click.stop>
                                    重置
                                  </el-button>
                                </div>
                              </div>
                              
                              <!-- DateTime介于类型时间选择器 -->
                              <div v-else-if="getFieldType(col.property) === 'datetime' && getActiveFilterType(col.property) === 'between'" class="datetime-between-inputs" @keydown.enter.stop.prevent="confirmFilter(col.property)">
                                <div class="datetime-between-row">
                                  <el-date-picker
                                    :model-value="getFilterValue(col.property, 'value1')"
                                    @update:model-value="(value: any) => setFilterValue(col.property, 'value1', value)"
                                    type="datetime"
                                    placeholder="开始时间"
                                    size="small"
                                    style="width: 150px"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    value-format="YYYY-MM-DD HH:mm:ss"
                                  />
                                  <span class="between-separator">~</span>
                                  <el-date-picker
                                    :model-value="getFilterValue(col.property, 'value2')"
                                    @update:model-value="(value: any) => setFilterValue(col.property, 'value2', value)"
                                    type="datetime"
                                    placeholder="结束时间"
                                    size="small"
                                    style="width: 150px"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    value-format="YYYY-MM-DD HH:mm:ss"
                                  />
                                </div>
                                <div class="filter-buttons">
                                  <el-button size="small" type="primary" @click="confirmFilter(col.property)" @click.stop>
                                    确定
                                  </el-button>
                                  <el-button size="small" @click="resetFilter(col.property)" @click.stop>
                                    重置
                                  </el-button>
                                </div>
                              </div>
                              
                            </div>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        
        <!-- 操作列 -->
        <el-table-column 
          v-if="showDetailButton || showEditButton || showDeleteButton || $slots.action"
          label="操作" 
          :width="getOperationColumnWidth()"
          fixed="right"
          align="center"
        >
          <template #default="{ row }">
            <div
              style="display: flex; gap: 8px; justify-content: center; align-items: center;"
              :style="{ flexWrap: operationNoWrap ? 'nowrap' : 'wrap', whiteSpace: operationNoWrap ? 'nowrap' : 'normal' }"
            >
              <!-- 编辑按钮 -->
              <el-button 
                v-if="showEditButton"
                type="primary" 
                size="small"
                :icon="View"
                plain
                @click="handleEdit(row)"
              />
              <!-- 删除按钮 -->
              <el-button 
                v-if="showDeleteButton"
                type="danger" 
                size="small"
                :icon="Delete"
                plain
                @click="handleDelete(row)"
              />
              <!-- 详情按钮 -->
              <el-button 
                v-if="showDetailButton && !showEditButton && !showDeleteButton"
                type="primary" 
                size="small" 
                @click="handleDetail(row)"
              >
                详情
              </el-button>
              <!-- 自定义操作插槽 -->
              <slot name="action" :row="row"></slot>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页器 -->
      <div v-if="pagination?.show" class="pagination-wrapper">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="currentPageSize"
          :page-sizes="pagination?.pageSizes || [10, 20, 50, 100]"
          :total="pagination?.total || 0"
          :layout="pagination?.layout || 'total, sizes, prev, pager, next, jumper'"
          :size="pagination?.small !== false ? 'small' : 'default'"
          @size-change="handlePageSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </template>
  
  <script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import { Filter, Setting, Download, CaretTop, CaretBottom, Edit, Delete, View } from '@element-plus/icons-vue'
  
  // 分页配置接口
  interface PaginationConfig {
    show?: boolean // 是否显示分页器
    page?: number // 当前页码
    pageSize?: number // 每页数量
    total?: number // 总数据量
    pageSizes?: number[] // 每页数量选项
    layout?: string // 分页器布局
    small?: boolean // 是否使用小尺寸分页器
  }

  // Props
  interface Props {
    data: any[]
    loading?: boolean
    showColumnSelector?: boolean
    showExport?: boolean
    showDetailButton?: boolean
    showEditButton?: boolean
    showDeleteButton?: boolean
    operationNoWrap?: boolean
    showSelection?: boolean
    defaultSelection?: any[] // 预设选中的行数据
    model?: Record<string, string> // 接口返回的model字段，键为字段名，值为类型字符串（如 "String", "DateTime", "Int64" 等）
    columnLabels?: Record<string, string> // 表头字段中文映射
    columnWidths?: Record<string, number> // 自定义列宽映射，键为字段名，值为宽度(px)
    columnOrder?: string[] // 自定义列排序，优先显示的字段名数组
    hiddenColumns?: string[] // 页面级需要隐藏的字段
    maxHeight?: number // 表格最大高度
    activeRowKey?: string | number | null
    // 分页配置对象
    pagination?: PaginationConfig
  }
  
  const props = withDefaults(defineProps<Props>(), {
    loading: false,
    showColumnSelector: true,
    showExport: true,
    showDetailButton: false,
    showEditButton: false,
    showDeleteButton: false,
    operationNoWrap: false,
    showSelection: false,
    defaultSelection: () => [],
    model: undefined,
    columnLabels: undefined,
    columnWidths: undefined,
    columnOrder: undefined,
    hiddenColumns: () => [],
    maxHeight: undefined,
    activeRowKey: null,
    pagination: () => ({
      show: false,
      page: 1,
      pageSize: 10,
      total: 0,
      pageSizes: [10, 20, 50, 100],
      layout: 'total, sizes, prev, pager, next, jumper',
      small: true
    })
  })

  // 定义事件
  const emit = defineEmits<{
    detail: [row: any]
    edit: [row: any]
    delete: [row: any]
    sort: [column: string, type: number]
    filter: [filters: any[], currentSelection?: any[]]
    'selection-change': [selection: any[]]
    // 分页相关事件
    'page-change': [page: number]
    'page-size-change': [pageSize: number]
  }>()
  
  // 计算操作列宽度
  const getOperationColumnWidth = () => {
    let buttonCount = 0
    if (props.showEditButton) buttonCount++
    if (props.showDeleteButton) buttonCount++
    if (props.showDetailButton && !props.showEditButton && !props.showDeleteButton) buttonCount++
    // 每个图标按钮约40px，详情按钮约60px，加上间距
    if (props.showDetailButton && !props.showEditButton && !props.showDeleteButton) {
      // 有自定义插槽时需要更宽
      return 200
    }
    // 有自定义插槽时增加宽度
    return Math.max(200, buttonCount * 40 + (buttonCount - 1) * 8 + 100)
  }
    // 处理选择变化
   const handleSelectionChange = (selection: any[]) => {
    // 如果正在设置默认选中项，跳过事件触发，防止无限循环
    if (isSettingDefaultSelection.value) return
    
    // 保存当前选择状态
    currentSelection.value = [...selection]
    
    emit('selection-change', selection)
  }
  // 编辑按钮点击事件
  const handleEdit = (row: any) => {
    emit('edit', row)
  }
  
  // 删除按钮点击事件
  const handleDelete = (row: any) => {
    emit('delete', row)
  }

  // 分页事件处理
  const handlePageChange = (page: number) => {
    currentPage.value = page
    emit('page-change', page)
  }

  const handlePageSizeChange = (pageSize: number) => {
    currentPageSize.value = pageSize
    currentPage.value = 1 // 改变页大小时重置到第一页
    emit('page-size-change', pageSize)
  }

  const getRowClassName = ({ row }: { row: any }) => {
    if (props.activeRowKey === null || props.activeRowKey === undefined || props.activeRowKey === '') return ''
    const rowKey = row?.Id ?? row?.id
    return String(rowKey ?? '') === String(props.activeRowKey) ? 'dynamic-table-active-row' : ''
  }
  
// 响应式数据
const tableRef = ref<any>(null)
const isSettingDefaultSelection = ref(false) // 防止无限循环的标志
const activeFilters = ref<Map<string, any>>(new Map())
const columnFilters = ref<Map<string, any>>(new Map())

// 排序状态
const sortState = ref<{column: string, type: number} | null>(null)

// 分页相关响应式数据
const currentPage = ref(props.pagination?.page || 1)
const currentPageSize = ref(props.pagination?.pageSize || 10)

// 选择状态保持
const currentSelection = ref<any[]>([]) // 保存当前选择的项目

// 列筛选器相关
const showColumnSelector = ref(false)
const showColumnSelectorPopup = ref(false)
const visibleColumns = ref<string[]>([])
const allColumns = ref<Array<{key: string, label: string, width?: number, minWidth?: number}>>([])
const tableColumns = ref<Array<{prop: string, label: string, width?: number, minWidth?: number}>>([])
const filterConfig = ref<any[]>([])

const systemFieldNames = ['Id', 'ISDELETED', 'id',"检测数据格式描述"]
const hiddenColumnNames = computed(() => new Set((props.hiddenColumns || []).map((name) => String(name).toLowerCase())))

const shouldIncludeField = (key: string, modelType?: string, sampleValue?: any) => {
  const lowerKey = key.toLowerCase()

  if (hiddenColumnNames.value.has(lowerKey)) return false
  if (systemFieldNames.some(name => name.toLowerCase() === lowerKey)) return false
  if (lowerKey.includes('id')) return false
  if (lowerKey.includes('json')) return false
  if (lowerKey.includes('isdeleted')) return false

  if (modelType) {
    const typeLower = modelType.toLowerCase()
    if (
      typeLower.includes('list') ||
      typeLower.includes('[]') ||
      typeLower.includes('dictionary') ||
      typeLower.includes('map') ||
      typeLower.includes('collection')
    ) {
      return false
    }
  } else if (sampleValue !== undefined) {
    if (Array.isArray(sampleValue)) return false
    if (sampleValue && typeof sampleValue === 'object' && !(sampleValue instanceof Date)) return false
  }

  return true
}

// 生成表格列配置
const generateTableColumns = (data: any[] = []) => {
  const firstItem = data[0] || {}
  const columns: Array<{prop: string, label: string, width?: number, minWidth?: number}> = []
  const allColumnsData: Array<{key: string, label: string, width?: number, minWidth?: number}> = []
  const fields: Array<{ key: string, modelType?: string }> = []

  if (props.model && typeof props.model === 'object') {
    for (const key of Object.keys(props.model)) {
      const modelType = props.model[key]
      const sampleValue = firstItem ? firstItem[key] : undefined
      if (shouldIncludeField(key, modelType, sampleValue)) {
        fields.push({ key, modelType })
      }
    }
  } else {
    for (const key of Object.keys(firstItem || {})) {
      const sampleValue = firstItem[key]
      if (shouldIncludeField(key, undefined, sampleValue)) {
        fields.push({ key })
      }
    }
  }

  const fieldKeys = fields.map(field => field.key)

  if (fieldKeys.length === 0) {
    return
  }

  // 如果指定了 columnOrder，按指定顺序排列字段（未指定的字段排在后面）
  if (props.columnOrder && props.columnOrder.length > 0) {
    const orderMap = new Map(props.columnOrder.map((key, idx) => [key, idx]))
    fields.sort((a, b) => {
      const orderA = orderMap.has(a.key) ? orderMap.get(a.key)! : Number.MAX_SAFE_INTEGER
      const orderB = orderMap.has(b.key) ? orderMap.get(b.key)! : Number.MAX_SAFE_INTEGER
      return orderA - orderB
    })
  }

  for (let i = 0; i < fields.length; i++) {
    const { key, modelType } = fields[i]
    const isLastColumn = i === fields.length - 1
    const fieldType = modelType || null
    
    // 根据字段名和类型判断宽度
    let width = undefined // 不设置固定宽度，让列自适应
    let label = props.columnLabels?.[key] || key
    const labelLength = [...String(label)].length
    const computedMinWidth = Math.max(120, labelLength * 18)

    // 根据字段类型或字段名判断宽度
    if (fieldType) {
      const typeLower = fieldType.toLowerCase()
      if (typeLower.includes('datetime') || typeLower.includes('date') || typeLower.includes('time')) {
        width = 180
      } else if (typeLower.includes('int64') || typeLower.includes('int32') || typeLower.includes('int')) {
        width = 120
      } else if (typeLower.includes('boolean')) {
        width = 100
        if (key.includes('ISDELETED') || key.includes('IsDeleted') || key.includes('isDeleted')) {
          label = '是否删除'
        }
      } else if (key.length > 10) {
        width = 200 // 长字段名给更宽的空间
      }
    } else {
      // 如果没有model，使用原来的逻辑
      if (key.includes('时间') || key.includes('Time') || key.includes('Date')) {
        width = 180
      } else if (key.includes('id') || key.includes('Id') || key.includes('ID')) {
        width = 120
      } else if (key.includes('ISDELETED') || key.includes('IsDeleted') || key.includes('isDeleted')) {
        width = 100
        label = '是否删除'
      } else if (key.length > 10) {
        width = 200 // 长字段名给更宽的空间
      }
    }
    
    // 确保列宽度至少能展示表头文本
    if (width && width < computedMinWidth) {
      width = computedMinWidth
    }

    // 自定义列宽覆盖自动计算的宽度
    if (props.columnWidths && props.columnWidths[key]) {
      width = props.columnWidths[key]
    }
    
    // 最后一列不设置固定宽度，让它自适应填充剩余空间
    if (isLastColumn) {
      width = undefined
    }
    
    // 为 DynamicTable 生成列配置（使用 prop）
    columns.push({
      prop: key,
      label: label,
      width: width,
      minWidth: computedMinWidth
    })
    
    // 为列选择器生成配置（使用 key）
    allColumnsData.push({
      key: key,
      label: label,
      width: width,
      minWidth: computedMinWidth
    })
  }
  
  allColumns.value = allColumnsData
  tableColumns.value = columns
  
  // 默认全选所有列
  visibleColumns.value = allColumnsData.map(col => col.key)
  
  // 生成筛选配置
  generateFilterConfig()
}

// 将model中的类型字符串转换为筛选配置使用的类型
const convertModelTypeToFilterType = (modelType: string): string => {
  if (!modelType) return 'string'
  
  const typeLower = modelType.toLowerCase()
  
  // 处理可空类型（如 "Boolean?"）
  const baseType = typeLower.replace('?', '').trim()
  
  if (baseType.includes('datetime') || baseType.includes('date') || baseType.includes('time')) {
    return 'datetime'
  } else if (baseType.includes('int64') || baseType.includes('long')) {
    return 'int64'
  } else if (baseType.includes('int32') || baseType.includes('int')) {
    return 'int32'
  } else if (baseType.includes('boolean') || baseType.includes('bool')) {
    return 'boolean'
  } else if (baseType.includes('string') || baseType.includes('str')) {
    return 'string'
  } else if (baseType.includes('number') || baseType.includes('decimal') || baseType.includes('double') || baseType.includes('float')) {
    return 'int64' // 数值类型统一使用int64
  } else {
    return 'string' // 默认返回string
  }
}

// 生成筛选配置
const generateFilterConfig = () => {
  const config = []

  // 优先从model中获取字段和类型
  if (props.model && typeof props.model === 'object') {
    // 从model对象中获取所有字段
    for (const key in props.model) {
      const modelType = props.model[key]
      const sampleValue = props.data && props.data.length > 0 ? props.data[0][key] : undefined
      if (shouldIncludeField(key, modelType, sampleValue)) {
        const fieldType = convertModelTypeToFilterType(modelType)
        
        config.push({
          FieldName: key,
          FiedType: fieldType,
          Type: 3, // 数据过滤
          Value1: '',
          Value2: ''
        })
      }
    }
  } else if (props.data && props.data.length > 0) {
    // 如果没有model，从数据中推断类型（保持向后兼容）
    const firstItem = props.data[0]
    for (const key in firstItem) {
      const value = firstItem[key]
      if (shouldIncludeField(key, undefined, value)) {
        let fieldType = ''
        
        // 根据字段名和值判断类型
        if (key.includes('时间') || key.includes('Time') || key.includes('Date')) {
          fieldType = 'datetime'
        } else if (key.includes('id') || key.includes('Id') || key.includes('ID')) {
          fieldType = 'int64'
        } else if (key.includes('ISDELETED') || key.includes('IsDeleted') || key.includes('isDeleted')) {
          fieldType = 'boolean'
        } else if (typeof value === 'boolean') {
          fieldType = 'boolean'
        } else if (typeof value === 'number') {
          fieldType = value >= -2147483648 && value <= 2147483647 ? 'int32' : 'int64'
        } else if (value instanceof Date || /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
          fieldType = 'datetime'
        } else {
          fieldType = 'string'
        }
        
        config.push({
          FieldName: key,
          FiedType: fieldType,
          Type: 3, // 数据过滤
          Value1: '',
          Value2: ''
        })
      }
    }
  }
  
  filterConfig.value = config
}

// 监听数据变化和model变化，自动生成列配置
watch([() => props.data, () => props.model, () => props.hiddenColumns], ([newData, newModel]) => {
  const hasData = Array.isArray(newData) && newData.length > 0
  const hasModel = newModel && typeof newModel === 'object' && Object.keys(newModel).length > 0
  if (hasData || hasModel) {
    generateTableColumns(hasData ? newData : [])
  }
}, { immediate: true })

// 监听数据和预设选中项变化，设置表格选中状态
watch([() => props.data, () => props.defaultSelection], ([newData, newDefaultSelection]) => {
  if (tableRef.value && Array.isArray(newData) && Array.isArray(newDefaultSelection) && newDefaultSelection.length > 0) {
    // 使用 nextTick 确保表格已经渲染完成
    nextTick(() => {
      setDefaultSelection(newData, newDefaultSelection)
    })
  }
}, { immediate: true })

// 设置预设选中项
const setDefaultSelection = (data: any[], defaultSelection: any[]) => {
  if (!tableRef.value || !Array.isArray(data) || !Array.isArray(defaultSelection)) return
  
  // 设置标志，防止触发selection-change事件
  isSettingDefaultSelection.value = true
  
  try {
    // 清空当前选中项
    tableRef.value.clearSelection()
    
    // 根据ID匹配并设置选中项
    defaultSelection.forEach(selectedItem => {
      const selectedId = selectedItem.Id || selectedItem.id
      if (selectedId) {
        const matchedRow = data.find(row => {
          const rowId = row.Id || row.id
          return rowId === selectedId
        })
        if (matchedRow) {
          tableRef.value.toggleRowSelection(matchedRow, true)
        }
      }
    })
  } finally {
    // 重置标志
    isSettingDefaultSelection.value = false
  }
}
  
  // 计算属性 - 直接使用props.data，筛选由后端处理
  const filteredData = computed(() => {
    return props.data
  })
  
  // 获取字段的筛选配置
  const getFilterConfig = (columnProp: string) => {
    return filterConfig.value.find(config => config.FieldName === columnProp)
  }
  
  // 获取筛选选项
  const getFilterOptions = (columnProp: string) => {
    const config = getFilterConfig(columnProp)
    if (!config || config.Type !== 3) return []
    
    const fieldType = config.FiedType || getDataType(columnProp)
    const options = []
    
    switch (fieldType.toLowerCase()) {
      case 'string':
        options.push(
          { label: '包含', value: 'contains' },
          { label: '不包含', value: 'not_contains' },
          { label: '等于', value: 'equals' }
        )
        break
      case 'int32':
      case 'int64':
      case 'int':
      case 'number':
        options.push(
          { label: '等于', value: 'equals' },
          { label: '大于', value: 'greater' },
          { label: '小于', value: 'less' },
          { label: '介于', value: 'between' }
        )
        break
      case 'date':
      case 'datetime':
      case 'time':
        options.push(
          { label: '等于', value: 'equals' },
          { label: '大于', value: 'greater' },
          { label: '小于', value: 'less' },
          { label: '介于', value: 'between' }
        )
        break
      case 'boolean':
        options.push(
          { label: 'True', value: 'true' },
          { label: 'False', value: 'false' }
        )
        break
    }
    
    return options
  }
  
  // 判断数据类型
  const getDataType = (columnProp: string) => {
    const sampleData = props.data[0]
    if (!sampleData || !sampleData[columnProp]) return 'string'
    
    const value = sampleData[columnProp]
    
    if (typeof value === 'boolean') return 'boolean'
    if (typeof value === 'number') return 'number'
    if (value instanceof Date || /^\d{4}-\d{2}-\d{2}/.test(value)) return 'date'
    return 'string'
  }
  
  // 获取字段类型
  const getFieldType = (columnProp: string) => {
    const config = getFilterConfig(columnProp)
    return config?.FiedType || getDataType(columnProp)
  }
  
  // 获取活跃筛选类型
  const getActiveFilterType = (columnProp: string) => {
    return columnFilters.value.get(columnProp)?.type || ''
  }
  
  // 获取筛选值
  const getFilterValue = (columnProp: string, key: string) => {
    return columnFilters.value.get(columnProp)?.[key] || ''
  }

  
  // 设置筛选类型
  const setFilterType = (columnProp: string, filterType: string) => {
    if (!columnFilters.value.has(columnProp)) {
      columnFilters.value.set(columnProp, { type: '', value1: '', value2: '' })
    }
    const filter = columnFilters.value.get(columnProp)
    if (filter) {
      filter.type = filterType
      // 不清空已输入的值，保持用户输入的内容
    }
  }
  
  // 设置筛选值
  const setFilterValue = (columnProp: string, key: string, value: any) => {
    if (!columnFilters.value.has(columnProp)) {
      columnFilters.value.set(columnProp, { type: '', value1: '', value2: '' })
    }
    const filter = columnFilters.value.get(columnProp)
    if (filter) {
      filter[key] = value
      // 只保存输入值，不自动应用筛选
    }
  }

  // 确认筛选
  const confirmFilter = (columnProp: string) => {
    const filter = columnFilters.value.get(columnProp)
    
    if (!filter || !filter.type) {
      ElMessage.warning('请先选择筛选条件')
      return
    }
    
    if (!filter.value1) {
      ElMessage.warning('请输入筛选值')
      return
    }
    
    // 将列筛选添加到活动筛选
    activeFilters.value.set(columnProp, {
      type: filter.type,
      value1: filter.value1,
      value2: filter.value2
    })
    
    // 构建筛选参数并触发事件（不包含排序）
    const filterParams = buildFilterOnlyParams()
    
    // 触发筛选事件，同时传递当前选择状态用于恢复
    emit('filter', filterParams, currentSelection.value)
    
    // 根据筛选类型显示不同的提示信息
    let message = ''
    switch (filter.type) {
      case 'contains':
        message = `已应用筛选: 包含 "${filter.value1}"`
        break
      case 'not_contains':
        message = `已应用筛选: 不包含 "${filter.value1}"`
        break
      case 'equals':
        message = `已应用筛选: 等于 "${filter.value1}"`
        break
      case 'greater':
        message = `已应用筛选: 大于 "${filter.value1}"`
        break
      case 'less':
        message = `已应用筛选: 小于 "${filter.value1}"`
        break
      case 'between':
        message = `已应用筛选: 介于 "${filter.value1}" 到 "${filter.value2}"`
        break
      case 'true':
        message = `已应用筛选: 为 True`
        break
      case 'false':
        message = `已应用筛选: 为 False`
        break
      default:
        message = `已应用筛选: ${filter.type} - ${filter.value1}`
    }
    
    ElMessage.success(message)
  }
  
  // 重置筛选
  const resetFilter = (columnProp: string) => {
    // 清空输入值
    if (columnFilters.value.has(columnProp)) {
      const filter = columnFilters.value.get(columnProp)
      if (filter) {
        filter.value1 = ''
        filter.value2 = ''
      }
    }
    
    // 移除活动筛选
    activeFilters.value.delete(columnProp)
    
    // 构建筛选参数并触发事件（不包含排序）
    const filterParams = buildFilterOnlyParams()
    emit('filter', filterParams)
    
    ElMessage.success('筛选条件已重置')
  }
  
// 处理筛选
const handleFilter = (columnProp: string, command: string, event?: Event) => {
  if (command.startsWith('filter_')) {
    // 修复解析逻辑：从 command 中提取筛选类型
    // command 格式: filter_${columnProp}_${filterType}
    const prefix = `filter_${columnProp}_`
    const filterType = command.replace(prefix, '')
    
    // 对于布尔类型，直接应用筛选
    if (getFieldType(columnProp) === 'boolean' && (filterType === 'true' || filterType === 'false')) {
      // 直接应用布尔筛选
      activeFilters.value.set(columnProp, {
        type: filterType,
        value1: filterType,
        value2: ''
      })
      
      // 显示筛选提示
      ElMessage.success(`已应用筛选: ${filterType === 'true' ? '为 True' : '为 False'}`)
    } else {
      setFilterType(columnProp, filterType)
      // 不再自动应用筛选，等待用户点击确定按钮
    }
  }
}

  
  
  
  // 应用筛选到单个数据项
  const applyFilterToItem = (item: any, column: string, filter: any) => {
    const value = item[column]
    if (value === null || value === undefined) return false
    
    let result = false
    switch (filter.type) {
      case 'contains':
        result = String(value).includes(filter.value1)
        break
      case 'not_contains':
        result = !String(value).includes(filter.value1)
        break
      case 'equals':
        result = String(value) === filter.value1
        break
      case 'greater':
        // 对于DateTime类型，比较时间戳
        if (filter.value1 && (typeof value === 'string' || value instanceof Date)) {
          const valueTime = new Date(value).getTime()
          const filterTime = new Date(filter.value1).getTime()
          result = valueTime > filterTime
        } else {
          result = Number(value) > Number(filter.value1)
        }
        break
      case 'less':
        // 对于DateTime类型，比较时间戳
        if (filter.value1 && (typeof value === 'string' || value instanceof Date)) {
          const valueTime = new Date(value).getTime()
          const filterTime = new Date(filter.value1).getTime()
          result = valueTime < filterTime
        } else {
          result = Number(value) < Number(filter.value1)
        }
        break
      case 'between':
        // 对于DateTime类型，比较时间戳范围
        if (filter.value1 && filter.value2 && (typeof value === 'string' || value instanceof Date)) {
          const valueTime = new Date(value).getTime()
          const startTime = new Date(filter.value1).getTime()
          const endTime = new Date(filter.value2).getTime()
          result = valueTime >= startTime && valueTime <= endTime
        } else {
          result = Number(value) >= Number(filter.value1) && Number(value) <= Number(filter.value2)
        }
        break
      case 'true':
        result = Boolean(value) === true
        break
      case 'false':
        result = Boolean(value) === false
        break
      default:
        result = true
    }
    
    return result
  }
  
  // 列筛选器相关方法
  const toggleColumnSelector = () => {
    showColumnSelectorPopup.value = !showColumnSelectorPopup.value
  }

  const toggleColumn = (columnKey: string) => {
    if (columnKey === '编码') return // 编码列不能取消选择
    
    const index = visibleColumns.value.indexOf(columnKey)
    if (index > -1) {
      visibleColumns.value.splice(index, 1)
    } else {
      visibleColumns.value.push(columnKey)
    }
  }

  const selectAllColumns = () => {
    visibleColumns.value = allColumns.value.map(col => col.key)
    ElMessage.success('已选择所有列')
  }

  // 点击外部关闭列选择器
  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement
    const selectorWrapper = document.querySelector('.column-selector-wrapper')
    if (selectorWrapper && !selectorWrapper.contains(target)) {
      showColumnSelectorPopup.value = false
    }
  }

  // 计算可见的列
  const visibleTableColumns = computed(() => {
    if (visibleColumns.value.length === 0) {
      return tableColumns.value
    }
    return tableColumns.value.filter((col: any) => visibleColumns.value.includes(col.prop))
  })

  // 生命周期钩子
  onMounted(() => {
    // 添加点击外部关闭事件
    document.addEventListener('click', handleClickOutside)
  })

  onUnmounted(() => {
    // 移除事件监听
    document.removeEventListener('click', handleClickOutside)
  })

  // 格式化时间显示
  const formatDateTime = (dateTimeStr: string) => {
    if (!dateTimeStr || dateTimeStr === '0001-01-01 00:00:00') {
      return '-'
    }
    try {
      const date = new Date(dateTimeStr)
      if (isNaN(date.getTime())) {
        return '-'
      }
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    } catch (error) {
      return '-'
    }
  }

  // 导出CSV功能
  const exportToCSV = async () => {
    if (filteredData.value.length === 0) {
      ElMessage.warning('没有数据可导出')
      return
    }

    const [xlsxModule, fileSaverModule] = await Promise.all([
      import('xlsx'),
      import('file-saver')
    ])

    const XLSX = xlsxModule.default || xlsxModule
    const saveAs = fileSaverModule.saveAs || fileSaverModule.default?.saveAs || fileSaverModule.default
    if (typeof saveAs !== 'function') {
      throw new Error('file-saver 加载失败')
    }

    // 根据可见列动态构建CSV数据
    const csvData = filteredData.value.map(item => {
      const row: any = {}
      
      for (const column of allColumns.value) {
        if (visibleColumns.value.includes(column.key)) {
          if (column.key.includes('ISDELETED') || column.key.includes('IsDeleted') || column.key.includes('isDeleted')) {
            row[column.label] = item[column.key] ? '是' : '否'
          } else if (column.key.includes('时间') || column.key.includes('Time') || column.key.includes('Date')) {
            row[column.label] = formatDateTime(item[column.key])
          } else {
            row[column.label] = item[column.key] || '-'
          }
        }
      }
      
      return row
    })

    // 转换为CSV
    const ws = XLSX.utils.json_to_sheet(csvData)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, '数据列表')
    
    // 导出文件
    const wbout = XLSX.write(wb, { bookType: 'csv', type: 'array' })
    const blob = new Blob([wbout], { type: 'application/octet-stream' })
    saveAs(blob, `数据列表_${new Date().toISOString().slice(0, 10)}.csv`)
    
    ElMessage.success(`CSV文件导出成功，共 ${filteredData.value.length} 条数据，包含 ${visibleColumns.value.length} 列`)
  }

  // 排序处理函数
  const handleSort = (column: string, type: number) => {
    // 如果点击的是当前已激活的同类型排序，则取消排序
    if (sortState.value && sortState.value.column === column && sortState.value.type === type) {
      // 取消排序
      sortState.value = null;
      // 触发一个特殊的排序事件，表示取消排序
      emit('sort', column, 0); // 0 表示取消排序
    } else {
      // 设置新的排序状态
      sortState.value = { column, type };
      emit('sort', column, type);
    }
    
    // 构建包含排序和筛选的完整参数并触发事件
    const allParams = buildFilterParams();
    emit('filter', allParams, currentSelection.value);
  }

  // 获取排序状态
  const getSortState = (column: string) => {
    if (sortState.value && sortState.value.column === column) {
      return sortState.value.type;
    }
    return null; // 未排序状态
  }

  // 构建排序参数
   const buildSortParams = () => {
    const filters = []
    
    // 添加排序参数
    if (sortState.value) {
      filters.push({
        FieldName: sortState.value.column,
        FiedType: getFieldType(sortState.value.column),
        Type: sortState.value.type, // 1:升序, 2:降序
        Value1: '',
        Value2: ''
      })
    }
    
    return filters
  }

  // 构建筛选参数（不包含排序）
  const buildFilterOnlyParams = () => {
    const filters = []
    
    // 只添加筛选参数
    for (const [column, filter] of activeFilters.value) {
      const fieldType = getFieldType(column)
      let type = 3 // 数据过滤
      let value1 = ''
      let value2 = ''
      
      // 根据筛选类型设置参数
      switch (filter.type) {
        case 'contains':
          // 字符串：包含 Value1 = 条件值 Value2=""
          value1 = filter.value1
          value2 = ''
          break
        case 'not_contains':
          // 字符串：不包含 Value2 = 条件值 Value1=""
          value1 = ''
          value2 = filter.value1
          break
        case 'equals':
          // 字符串、时间、数值：等于 Value1 = 条件值 Value2 = ""
          value1 = filter.value1
          value2 = ''
          break
        case 'greater':
          // 时间、数值：大于 Value1 = 条件值 Value2=""
          value1 = filter.value1
          value2 = ''
          break
        case 'less':
          // 时间、数值：小于 Value2 = 条件值 Value1=""
          value1 = ''
          value2 = filter.value1
          break
        case 'between':
          // 时间、数值：介于 Value1 = 小值 Value2=大值
          value1 = filter.value1
          value2 = filter.value2
          break
        case 'true':
          // 布尔：value1等于"true"代表true
          value1 = 'true'
          value2 = ''
          break
        case 'false':
          // 布尔：value1等于"false"代表false
          value1 = 'false'
          value2 = ''
          break
      }
      
      filters.push({
        FieldName: column,
        FiedType: fieldType,
        Type: type,
        Value1: value1,
        Value2: value2
      })
    }
    
    return filters
  }

  // 构建筛选参数（包含排序和筛选）
 const buildFilterParams = () => {
    const filters = []
    
    // 添加排序参数
    if (sortState.value) {
      filters.push({
        FieldName: sortState.value.column,
        FiedType: getFieldType(sortState.value.column),
        Type: sortState.value.type, // 1:升序, 2:降序
        Value1: '',
        Value2: ''
      })
    }
    
    // 添加筛选参数
    for (const [column, filter] of activeFilters.value) {
      const fieldType = getFieldType(column)
      let type = 3 // 数据过滤
      let value1 = ''
      let value2 = ''
      
      // 根据筛选类型设置参数
      switch (filter.type) {
        case 'contains':
          // 字符串：包含 Value1 = 条件值 Value2=""
          value1 = filter.value1
          value2 = ''
          break
        case 'not_contains':
          // 字符串：不包含 Value2 = 条件值 Value1=""
          value1 = ''
          value2 = filter.value1
          break
        case 'equals':
          // 字符串、时间、数值：等于 Value1 = 条件值 Value2 = ""
          value1 = filter.value1
          value2 = ''
          break
        case 'greater':
          // 时间、数值：大于 Value1 = 条件值 Value2=""
          value1 = filter.value1
          value2 = ''
          break
        case 'less':
          // 时间、数值：小于 Value2 = 条件值 Value1=""
          value1 = ''
          value2 = filter.value1
          break
        case 'between':
          // 时间、数值：介于 Value1 = 小值 Value2=大值
          value1 = filter.value1
          value2 = filter.value2
          break
        case 'true':
          // 布尔：value1等于"true"代表true
          value1 = 'true'
          value2 = ''
          break
        case 'false':
          // 布尔：value1等于"false"代表false
          value1 = 'false'
          value2 = ''
          break
      }
      
      filters.push({
        FieldName: column,
        FiedType: fieldType,
        Type: type,
        Value1: value1,
        Value2: value2
      })
    }
    
    return filters
  }

  // 详情按钮点击事件
  const handleDetail = (row: any) => {
    emit('detail', row)
  }

  // 格式化单元格值，处理布尔值转换
  const formatCellValue = (value: any, columnProp: string) => {
    // 如果值是布尔类型，进行转换
    if (typeof value === 'boolean') {
      return value ? '是' : '否'
    }
    
    // 如果值是字符串形式的布尔值，也进行转换
    if (typeof value === 'string') {
      const lowerValue = value.toLowerCase()
      if (lowerValue === 'true') {
        return '是'
      } else if (lowerValue === 'false') {
        return '否'
      }
    }
    
    // 其他类型的值直接返回
    return value
  }

  // 监听 props 变化，同步分页状态
  watch(() => props.pagination?.page, (newPage) => {
    if (newPage !== undefined) {
      currentPage.value = newPage
    }
  })

  watch(() => props.pagination?.pageSize, (newPageSize) => {
    if (newPageSize !== undefined) {
      currentPageSize.value = newPageSize
    }
  })

  // 恢复选择状态的方法
  const restoreSelection = async (savedSelection: any[]) => {
    if (!tableRef.value || !Array.isArray(savedSelection) || savedSelection.length === 0) {
      return;
    }
    
    await nextTick()
    
    // 设置标志，防止触发selection-change事件
    isSettingDefaultSelection.value = true
    
    try {
      // 清除当前选择
      tableRef.value.clearSelection()
      
      // 恢复之前的选择
      savedSelection.forEach((item: any) => {
        const foundRow = props.data.find((row: any) => {
          const rowId = row.Id || row.id
          const itemId = item.Id || item.id
          return rowId && itemId && String(rowId) === String(itemId)
        })
        
        if (foundRow) {
          tableRef.value.toggleRowSelection(foundRow, true)
        }
      })
      
      // 更新当前选择状态
      currentSelection.value = [...savedSelection]
    } finally {
      // 重置标志
      setTimeout(() => {
        isSettingDefaultSelection.value = false
      }, 100)
    }
  }

  // 暴露方法给父组件
  defineExpose({
    clearAllFilters: () => {
      activeFilters.value.clear()
      columnFilters.value.clear()
      ElMessage.success('所有筛选条件已清除')
    },
    getActiveFilters: () => activeFilters.value,
    toggleColumnSelector,
    toggleColumn,
    selectAllColumns,
    visibleColumns: visibleColumns.value,
    exportToCSV,
    restoreSelection
  })
  </script>
  
  <style scoped>
  .dynamic-table-card {
    width: 100%;
    height: 100%;
    position: relative;
    min-height: 400px;
    display: flex;
    flex-direction: column;
  }

  :deep(.el-card__body) {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0 !important; /* 覆盖默认padding以确保表格贴边 */
  }

  /* 表格容器样式调整 */
  :deep(.el-table) {
    flex: 1;
    height: 0 !important; /* 关键：让表格在flex容器中正确计算高度 */
  }
  
  .dynamic-table {
    width: 100%;
    position: relative;
  }
  
   .table-header-filter {
     position: relative;
     display: flex;
     flex-direction: column;
     gap: 8px;
   }
  
  .header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  
  .header-title {
    font-weight: bold;
    color: #606266;
    flex: 1;
  }
  
  .header-controls {
    display: flex;
    align-items: center;
  }
  
  .filter-controls {
    display: flex;
    align-items: center;
  }
  
  .filter-btn {
    flex-shrink: 0;
  }

  .filter-input-item {
    padding: 8px;

  }

  .input-with-buttons {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .filter-buttons {
    display: flex;
    gap: 4px;
    justify-content: flex-end;
  }

  .filter-input-item .el-input {
    flex: 1;
  }

  /* 确保输入框的交互不会关闭下拉菜单 */
  .filter-input-item .el-input__inner {
    pointer-events: auto;
  }

  .between-inputs {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .between-input-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .between-separator {
    color: #666;
    font-weight: bold;
    font-size: 14px;
    margin: 0 4px;
  }

  .between-inputs .filter-buttons {
    display: flex;
    gap: 4px;
    justify-content: flex-end;
  }


  /* DateTime时间选择器样式 */
  .datetime-inputs {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .datetime-inputs .filter-buttons {
    display: flex;
    gap: 4px;
    justify-content: flex-end;
  }

  .datetime-between-inputs {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .datetime-between-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .datetime-between-inputs .filter-buttons {
    display: flex;
    gap: 4px;
    justify-content: flex-end;
  }


  /* 时间选择器面板层级控制 */
  :deep(.el-picker-panel) {
    z-index: 10000 !important;
  }

  :deep(.el-popper) {
    z-index: 10000 !important;
  }

  /* 下拉菜单的 z-index 设置 */
  :deep(.el-dropdown-menu) {
    z-index: 9999;
  }

  /* 筛选选项选中效果 */
  .filter-option-selected {
    background-color: #e6f7ff !important;
    color: #1890ff !important;
    font-weight: 500;
  }

  .filter-option-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .filter-option-label {
    flex: 1;
  }

  .filter-option-check {
    color: #1890ff;
    font-weight: bold;
    margin-left: 8px;
  }

  /* 下拉菜单项悬停效果 */
  :deep(.el-dropdown-menu__item) {
    transition: all 0.2s ease;
  }

  :deep(.el-dropdown-menu__item:hover) {
    background-color: #f5f5f5;
  }

  :deep(.el-dropdown-menu__item.filter-option-selected:hover) {
    background-color: #d6f0ff !important;
  }

  :deep(.el-table__row.dynamic-table-active-row > td) {
    background-color: #ecf5ff !important;
  }
  
  :deep(.el-table__header-wrapper) {
    .el-table__header {
      th {
        .cell {
          padding: 8px;
        }
      }
    }
  }
  
  :deep(.el-table__header) {
    th {
      background-color: #f5f7fa;
    }
  }

  /* 表格工具栏样式 */
  .table-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background-color: #fafafa;
    border-bottom: 1px solid #ebeef5;
    min-height: 48px;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
  }

  .table-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin: 0;
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .toolbar-right .el-button {
    margin: 0;
    transition: all 0.3s ease;
  }

  .toolbar-right .el-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .toolbar-right .el-button.is-circle {
    width: 32px;
    height: 32px;
  }

  /* 自定义列选择器样式 */
  .column-selector-wrapper {
    position: relative;
    display: inline-block;
  }

  .custom-column-selector {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    width: 220px;
    background: white;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    margin-top: 8px;
    animation: slideDown 0.2s ease-out;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .selector-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    border-bottom: 1px solid #ebeef5;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    font-weight: 600;
    font-size: 14px;
    color: #303133;
    border-radius: 8px 8px 0 0;
  }

  .selector-header span {
    flex: 1;
    font-size: 15px;
  }

  .selector-header .el-button {
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 4px;
    transition: all 0.2s ease;
  }

  .selector-header .el-button:hover {
    background-color: #409eff;
    color: white;
  }

  .selector-content {
    max-height: 240px;
    overflow-y: auto;
    padding: 8px 0;
    background: white;
    border-radius: 0 0 8px 8px;
  }

  .column-item {
    padding: 8px 16px;
    transition: all 0.2s ease;
    border-radius: 4px;
    margin: 2px 8px;
    cursor: pointer;
  }

  .column-item:hover {
    background-color: #f0f9ff;
    transform: translateX(2px);
  }

  .column-item .el-checkbox {
    width: 100%;
    margin: 0;
    pointer-events: none; /* 禁用checkbox的默认点击事件，使用父元素的点击事件 */
  }

  .column-item .el-checkbox__label {
    font-size: 14px;
    color: #606266;
    padding-left: 8px;
    font-weight: 500;
    cursor: pointer;
  }

  .column-item .el-checkbox.is-readonly .el-checkbox__label {
    color: #c0c4cc;
    font-weight: 400;
  }
  
  .no-columns-tip {
    padding: 20px;
    text-align: center;
    color: #909399;
    font-size: 14px;
  }

  /* 滚动条样式 */
  .selector-content::-webkit-scrollbar {
    width: 6px;
  }

  .selector-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .selector-content::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .selector-content::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  /* 排序按钮样式 */
  .sort-controls {
    margin-right: 8px;
  }

  .sort-icons-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1px;
    cursor: pointer;
    padding: 2px;
    border-radius: 4px;
    transition: all 0.2s ease;
  }

  .sort-icons-container:hover {
    background-color: #f5f7fa;
  }

  .sort-icon {
    width: 16px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    transition: all 0.2s ease;
    cursor: pointer;
  }

  .sort-icon:hover {
    color: #409eff;
  }

  .sort-icon.active {
    color: #409eff;
    font-weight: bold;
  }

  .sort-icon-up {
    margin-bottom: -1px;
  }

  .sort-icon-down {
    margin-top: -1px;
  }

  /* 表头控制区域布局 */
  .header-controls {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* 分页器样式 */
  .pagination-wrapper {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #e4e7ed;
    background: #fafafa;
    min-height: 44px;
    flex: 0 0 auto;
    /* 低分辨率/平板下分页内容超宽时允许容器内横向滚动，避免被裁掉看不到 */
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: thin;

    :deep(.el-pagination) {
      --el-pagination-font-size: 12px;
      --el-pagination-button-width: 28px;
      --el-pagination-button-height: 28px;
      width: auto;
      max-width: 100%;
      min-width: min(100%, max-content);
      min-width: 100%;
      height: auto;
      min-height: 28px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      row-gap: 6px;
      column-gap: 8px;
      white-space: normal;

      .el-pager {
        min-width: 0;
        flex-wrap: wrap;
        justify-content: center;
      }
      
      .el-pagination__total,
      .el-pagination__sizes,
      .el-pagination__jump {
        flex-shrink: 0;
        font-size: 12px;
      }

      .el-pagination__sizes {
        max-width: 110px;
      }

      .el-pagination__jump {
        max-width: 160px;
      }
    }
  }

  @media (max-width: 900px) {
    .pagination-wrapper {
      padding: 8px 4px;

      :deep(.el-pagination) {
        column-gap: 4px;

        .el-pagination__sizes,
        .el-pagination__jump {
          margin-left: 0;
          margin-right: 0;
        }
      }
    }
  }
  </style>
